import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from 'context/auth'
import { setupAxios, consumeHandoffToken } from 'utils/auth-helper'
import { TranslationProvider } from 'translation'
import App from 'App'
import { BrowserRouter } from 'react-router-dom'

// Must run before AuthProvider reads localStorage on first render.
consumeHandoffToken()
setupAxios()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <TranslationProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </TranslationProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
